// src/components/AIMito/formatters.ts
import { IProject } from 'app/services/responseTypes';
import { IClientBusiness } from 'app/services/responseTypes';
import { IUser } from 'app/services/user';

export const formatProjects = (arr: IProject[]) =>
  arr
    .map((p) => `• ${p.title || `${p.year} Tax Return`} – status: ${p.status}`)
    .join('\n');

export const formatBusinesses = (arr: IClientBusiness[]) =>
  arr.map((b) => `• ${b.name}`).join('\n');

// src/components/AIMito/formatters.ts
/* src/components/AIMito/formatters.ts */
export const formatTeam = (arr: IUser[]) =>
  arr
    .map((u) => {
      const name = `${u.given_name} ${u.family_name}`;
      const email = u.email ?? '—';
      const link = u.accountant_profile?.schedule_platform_link ?? '';

      /* ONE single line, valid HTML */
      const slot = link
        ? `<button type="button" class="reset-button" ` +
          `onclick="window.AOAopenExternal('${encodeURI(link).replace(
            /'/g,
            '&#39;',
          )}')">` +
          `Schedule&nbsp;an&nbsp;Appointment</button>`
        : '—';

      return `• ${name} – ${email} – ${slot}`;
    })
    .join('\n');
